/**
 * Color Block Grid
 * ----------------
 */

if($('.color-block-grid').length) {

    colorGridCleanup();
    $(window).on('resize', function () { colorGridCleanup(); });

    function colorGridCleanup() {

        let containerReference = $('#primary-header-row .container').first(),
            containerPadding = ($('#main-site-wrapper').width() - containerReference.outerWidth()) / 2;

        $('.color-block-grid').each(function () {

            let gridItems = $(this).find('.color-grid-item');

            if($(window).width() > 1200) {
                gridItems.each(function (i, e) {
                    // $(this).css({
                    //     'padding-left': containerPadding,
                    //     'padding-right': containerPadding
                    // });
                    if(i % 2) {
                        $(this).css('padding-right', containerPadding);
                    } else {
                        $(this).css('padding-left', containerPadding);
                    }
                });
            } else {
                gridItems.each(function (i, e) {
                    $(this).css({
                        'padding-left': '',
                        'padding-right': ''
                    });
                });
            }

        });

    }

}